import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../theme/color-palette';
import { BOGLE_REGULAR } from '../../../constants/constant';

const { PURPLE, BOLD_WHITE, ERROR_HIGH } = colors;

export const useStyles = makeStyles(() => ({
	container: {
		display: 'flex',
		margin: '10px 14px',
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		'@media (max-width: 680px)': {
			margin: '10px 0',
			padding: '5px',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
		},
	},
	saveCategory: {
		'@media (max-width: 680px)': {
			paddingTop: '0 !important',
			marginTop: '-5px !important',
		},
	},
	menuRow: {
		display: 'flex',
		'@media (max-width: 680px)': {
			flexDirection: 'column',
			justifyContent: 'flex-start',
		},
	},
	border: {
		position: 'relative',
		bottom: '-33px',
	},
	categoryFilter: {
		marginLeft: '15px',
		'@media (max-width: 680px)': {
			marginLeft: '0px !important',
		},
	},
	channelFilter: {
		marginLeft: '15px',
		'@media (max-width: 680px)': {
			marginLeft: '0px !important',
		},
	},
	formControl: {
		width: 170,
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
	},
	categoryFormControl: {
		width: '100%',
		'& label.Mui-focused': {
			color: PURPLE,
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE,
			},
		},
	},
	defaultSaved: {
		padding: '12px 16px',
		position: 'absolute',
		left: '40%',
		top: '260px',
		background: ' #EAF3E6',
		boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
		borderRadius: '4px',
		zIndex: 1,
	},

	defaultNotSaved: {
		padding: '12px 16px',
		position: 'absolute',
		left: '36%',
		top: '265px',
		background: '#FCE8E9',
		boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3)',
		borderRadius: '4px',
		zIndex: 1,
	},

	savedContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		height: '20px',
	},

	errorContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		height: '20px',
	},

	formatSavedText: {
		fontSize: '14px',
		letterSpacing: '0.25px',
		color: '#1D5F02',
	},
	formatErrorText: {
		fontSize: '14px',
		letterSpacing: '0.25px',
		color: '#9B1419',
	},
	modalBox: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '980px',
		background: '#fff',
		boxShadow: '0px 5px 10px 3px rgba(0, 0, 0, 0.15)',
		padding: '15px',
		maxHeight: '840px',
		overflowY: 'auto',
	},
	backButtonParent: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'left',
		columnGap: '10px'
	},
	cancelBtn: {
		border: '1px solid rgba(213, 214, 216, 1) !important',
		textTransform: 'none !important',
		padding: '0px 24px 0px 24px !important',
		color: 'rgba(60, 34, 138, 1) !important',
		borderRadius: '100px !important',
		fontSize: '16px !important',
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontWeight: '600 !important',
	},
	applyBtn: {
		textTransform: 'none !important',
		color: BOLD_WHITE,
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontWeight: '600 !important',
		fontSize: '16px !important',
		borderRadius: '100px !important',
		boxShadow: "none !important",
		padding: '0px 24px 0px 24px !important',
		'&:hover': {
			background: '#3C228A !important',
			cursor: 'pointer',
		},
	},
	modalHeaderTitle: {
		fontFamily: 'Bogle-Regular',
		fontSize: '18px',
		paddingTop: '4px',
	},
	businessHirerchyWrapper: {
		border: '1px solid #DADCE0',
		margin: '10px 0 20px 0',
		height: 'calc(100% - 110px)',
		overflow: 'auto',
	},
	hoverParent: {
		marginTop: '6px',
		'&:hover': {
			background: '#f2f2f2'
		},
	},
	backIcon: {
		height: '25px',
		width: "25px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		borderRadius: "100%",
		cursor: 'pointer',
		'&:hover': {
			background: `#f2f2f2 !important`,
		}
	},
	hoverEditIcon: {
		'&:hover': {
			background: `#f2f2f2 !important`,
		}
	},
	saveThis: {
		'& .MuiTypography-root':{
			fontFamily: `${BOGLE_REGULAR} !important`,
		}
	},
	modalFooter: {
		display: 'flex',
		alignItems: 'right',
		justifyContent: 'right',
		columnGap: '10px',
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontWeight: '600 !important',
		'& .MuiCheckbox-colorPrimary.Mui-checked': {
			color: `${PURPLE} !important`,
		},
		'& .MuiFormControlLabel-label': {
			color: 'rgba(46, 47, 50, 1) !important',
			fontSize: '14px !important',
		},
	},
	snackbar: {
		margin: '0 auto',
		padding: '0 10px',
		width: '98% !important',
	},
	hierarchyFilter: {
		border: '1 solid black',
	},
	tryAgainButton: {
		display: 'flex',
		height: '52px',
		alignItems: 'center',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	tryAgainText: {
		color: ERROR_HIGH,
		fontFamily: 'Bogle !important',
		fontSize: '14px',
		fontSeight: 400,
		lineHeight: '20px' /* 142.857% */,
		textDecorationLine: 'underline',
		textTransform: 'none',
	},
	input: {
		height: '28px',
		minWidth: '320px',
	},
	textField: {
		display: 'block',
		'& .MuiTextField-root': {
			marginTop: '8px !important'
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: `${PURPLE} !important`
		}
	}
}));

export const selectStyleMenu = {
	fontFamily: BOGLE_REGULAR,
	fontSize: 14,
	'&& .Mui-selected': {
		backgroundColor: BOLD_WHITE,
	},
	'&& .Mui-checked': {
		color: PURPLE,
	},
};
